import merge from 'lodash/merge'

export const types = {
  SET_MONTH_FILTER: 'SET_MONTH_FILTER',
  SET_MONTH_OPTIONS: 'SET_MONTH_OPTIONS'
}

export const createResource = (options = {}) => ({
  state: {
    months: 3,
    monthsOptions: [
      { value: 1, label: 'Last 1 month' },
      { value: 2, label: 'Last 2 months' },
      { value: 3, label: 'Last 3 months' },
      { value: 6, label: 'Last 6 months' }
    ],
    fullMonthsOptions: [
      { value: 1, label: 'Last 1 month' },
      { value: 2, label: 'Last 2 months' },
      { value: 3, label: 'Last 3 months' },
      { value: 6, label: 'Last 6 months' },
      { value: 9, label: 'Last 9 months' },
      { value: 12, label: 'Last 12 months' },
      { value: 15, label: 'Last 15 months' },
      { value: 18, label: 'Last 18 months' }
    ]
  },

  mutations: {
    [types.SET_MONTH_FILTER]: (state, { months }) => {
      state.months = months
    },

    [types.SET_MONTH_OPTIONS]: (state, { packageType }) => {
      if (packageType === 'advanced') {
        state.monthsOptions = state.fullMonthsOptions.slice(0, 6)
      } else if (packageType === 'premium') {
        state.monthsOptions = state.fullMonthsOptions
      }
      
    }
  },

  actions: {
    setMonthsFilter ({ commit }, months) {
      commit(types.SET_MONTH_FILTER, { months })
    },

    initPackageMonthsOptions( { commit }, packageType) {
      commit(types.SET_MONTH_OPTIONS, { packageType })
      
    }
  }
})

export const extendResourceByMonthFilter = resource => merge(createResource(), resource)
